import React from 'react';
import { createPortal } from 'react-dom';
import './CustomModal.css';

const CustomModal = ({
    isOpen,
    onClose,
    title,
    message,
    type = 'info', // 'info', 'success', 'error', 'confirm'
    onConfirm,
    confirmText = 'OK',
    cancelText = 'Cancel'
}) => {
    if (!isOpen) return null;

    // Determine button styles based on type
    let confirmBtnClass = 'orvion-btn-primary';
    if (type === 'error' || type === 'confirm') {
        // For confirm, we might want danger if it's a destructive action, 
        // but let's default to primary unless specified otherwise.
        // Actually, let's make 'confirm' use primary by default, but allow override if needed later.
        // For now, let's stick to a simple mapping.
        confirmBtnClass = 'orvion-btn-primary';
    }

    // If it's a destructive confirmation (like delete/signout), we might want a specific prop or type.
    // Let's assume 'confirm' is generic. If we need danger, we can pass a prop or use a 'danger' type.
    // Let's add a 'danger' type for destructive confirmations.
    if (type === 'danger') {
        confirmBtnClass = 'orvion-btn-danger';
    }

    return createPortal(
        <div className="orvion-modal-overlay" onClick={onClose}>
            <div className="orvion-modal-content" onClick={e => e.stopPropagation()}>
                <h3 className="orvion-modal-title">{title}</h3>
                <p className="orvion-modal-message">{message}</p>

                <div className="orvion-modal-actions">
                    {(type === 'confirm' || type === 'danger') && (
                        <button className="orvion-modal-btn orvion-btn-secondary" onClick={onClose}>
                            {cancelText}
                        </button>
                    )}

                    <button
                        className={`orvion-modal-btn ${confirmBtnClass}`}
                        onClick={() => {
                            if (onConfirm) onConfirm();
                            onClose();
                        }}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default CustomModal;
